<template lang="pug">
.container
  header
    main-header(
      :notificacao="false"
      :hasListagemModelo="false"
    )
  .card
    .card-body
      informacoes-conversa(
        :idConversa="idConversa",
        :voltar="'ouvidoria/home'",
        @statusChanged="setStatus"
      )

  el-row.voltar-container
    app-buttons-cadastro(
      :isPrimeiroPasso="false",
      :isUltimoPasso="true",
      :showButtonFinalizar="false"
      :showButtonEnviar="false"
      :showButtonCancelar="false"
      :showButtonDownload="isAmapa"
      @download="download",
      @voltar="voltar"
    )
</template>

<script>
import InformacoesConversa from '@/screens/central/components/comunicacao/InformacoesConversa'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import MainHeader from '@/components/MainHeader'
import {mapActions} from 'vuex'

export default {
  mixins: [
    AppNotificacao
  ],
  components: {
    InformacoesConversa,
    AppButtonsCadastro,
    MainHeader
  },
  computed: {
    isAmapa () {
      return process.env.ESTADO === 'ap'
    }
  },
  data () {
    return {
      idConversa: this.$route.params.idConversa,
      statusConversa: null
    }
  },
  methods: {
    ...mapActions({
      baixarPdfHistoricoConversa: 'processos/baixarHistoricoConversa'
    }),

    async download () {
      await this.baixarPdfHistoricoConversa(this.idConversa)
    },

    setStatus (status) {
      this.statusConversa = status
    },

    voltar () {
      this.$router.push({
        name: 'ouvidoria/home'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  flex-direction: column;
}
.voltar-container {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/ouvidoria/VisualizarConversa.vue